var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.94909C14 11.0466 10.8182 11.683 10.8182 15.5018C10.8182 17.4733 8.83082 17.6394 7.31818 17.6394C6.01173 17.6394 3.12709 17.1436 3.12709 15.5005C3.12709 11.6836 0 11.0473 0 6.94909C0 3.11118 3.36318 0 7.05282 0C10.7437 0 14 3.11118 14 6.94909Z",
    fill: "#FFD983"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65111 20.5924C9.65111 21.1193 8.22947 22.1833 6.99938 22.1833C5.76929 22.1833 4.34766 21.1193 4.34766 20.5924C4.34766 20.0655 5.76866 20.2742 6.99938 20.2742C8.22947 20.2742 9.65111 20.0655 9.65111 20.5924Z",
    fill: "#CCD6DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9957 6.46103C9.74688 6.21221 9.3447 6.21221 9.09588 6.46103L7.00034 8.55657L4.90479 6.46103C4.65597 6.21221 4.25379 6.21221 4.00497 6.46103C3.75615 6.70985 3.75615 7.11203 4.00497 7.36085L6.36397 9.71985V16.4564C6.36397 16.8083 6.64906 17.0928 7.00034 17.0928C7.35161 17.0928 7.6367 16.8083 7.6367 16.4564V9.71985L9.9957 7.36085C10.2445 7.11203 10.2445 6.70985 9.9957 6.46103Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.818 19.6385C10.818 20.341 10.2478 20.9112 9.54528 20.9112H4.45437C3.75182 20.9112 3.18164 20.341 3.18164 19.6385V15.8203H10.818V19.6385Z",
    fill: "#99AAB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18102 20.2744C2.87557 20.2744 2.60575 20.0536 2.5542 19.7424C2.4963 19.3962 2.73048 19.0678 3.0773 19.0106L10.7137 17.7378C11.0598 17.6755 11.3882 17.9141 11.4455 18.2609C11.5034 18.6071 11.2692 18.9355 10.9224 18.9927L3.28602 20.2655C3.25102 20.2718 3.21539 20.2744 3.18102 20.2744ZM3.18102 17.7289C2.87557 17.7289 2.60575 17.5081 2.5542 17.1969C2.4963 16.8507 2.73048 16.5224 3.0773 16.4651L10.7137 15.1924C11.0598 15.1306 11.3882 15.3686 11.4455 15.7155C11.5034 16.0616 11.2692 16.39 10.9224 16.4473L3.28602 17.72C3.25102 17.7264 3.21539 17.7289 3.18102 17.7289Z",
    fill: "#CCD6DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.350d85e377ace5146d13b1a44f198d24.svg";
export { ForwardRef as ReactComponent };